import { connect } from 'react-redux';

import CardsPanel from './CardsPanel';
import { getFilterIdentifierCount, resetCardFilters } from '../../filters/store/filtersSlice';
import {
  getCurrentSelection,
  setActiveSupplierAuthTab,
  setSupplierAuthorizationsCards,
} from '../store/supplierAuthorizationSlice';

const mapState = state => ({
  activeSupplierAuthTab: state.loadingManagement.supplierAuthorizations.activeSupplierAuthTab,
  currentSelection: getCurrentSelection(state),
  exchange: state.loadingManagement.filters.exchange,
  filterIdentifierCount: getFilterIdentifierCount(state),
  location: state.loadingManagement.filters.location,
  product: state.loadingManagement.filters.product,
  state: state.loadingManagement.filters.state,
  status: state.loadingManagement.filters.status,
  supplier: state.loadingManagement.filters.supplier,
  supplierAuthorizations: state.loadingManagement.supplierAuthorizations.supplierAuthorizations,
  supplierAuthorizationsCards:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsCards,
  supplierAuthorizationsPending:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsPending,
  type: state.loadingManagement.filters.type,
});

export default connect(mapState, {
  resetCardFilters,
  setActiveSupplierAuthTab,
  setSupplierAuthorizationsCards,
})(CardsPanel);
